"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTruncateMarkup = _interopRequireDefault(require("react-truncate-markup"));
var _angieslistReactComponents = require("angieslist-react-components");
var _stylesColors = _interopRequireDefault(require("angieslist-styles/js/stylesColors"));
var _certifiedPopOver = _interopRequireDefault(require("./certifiedPopOver"));
var _raqButton = _interopRequireDefault(require("./raqButton"));
var _featuredSPInfoHover = _interopRequireDefault(require("./featuredSPInfoHover"));
var _featuredIcons = _interopRequireDefault(require("./featuredIcons"));
var _wrapperUtils = require("./utils/wrapperUtils");
var certifiedIcon = require('./assets/angi-certified-card-tag.svg');
var FeaturedCardBody = function FeaturedCardBody(_ref) {
  var _context;
  var serviceProviderName = _ref.serviceProviderName,
    serviceProviderId = _ref.serviceProviderId,
    singleFeaturedPro = _ref.singleFeaturedPro,
    raqUrl = _ref.raqUrl,
    profileUrl = _ref.profileUrl,
    reviewsUrl = _ref.reviewsUrl,
    starRating = _ref.starRating,
    reviewCount = _ref.reviewCount,
    description = _ref.description,
    postalCode = _ref.postalCode,
    awards = _ref.awards,
    ratings = _ref.ratings,
    listedSinceYear = _ref.listedSinceYear,
    showReviewsLink = _ref.showReviewsLink,
    LinkWrapperComponent = _ref.LinkWrapperComponent,
    dataTrackingPropsForProfileViews = _ref.dataTrackingPropsForProfileViews,
    dataTrackingPropsForRaqBtn = _ref.dataTrackingPropsForRaqBtn;
  var truncatedSpName = function truncatedSpName(lines) {
    return /*#__PURE__*/_react["default"].createElement(_reactTruncateMarkup["default"], {
      lines: lines
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "featured-sp-title"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, serviceProviderName)));
  };
  var WrappedLink = (0, _wrapperUtils.createWrappedComponent)('a', LinkWrapperComponent);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-sp-card-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden-xs hidden-sm"
  }, !singleFeaturedPro ? [/*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-title-row",
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 6
  }, !!profileUrl ? /*#__PURE__*/_react["default"].createElement(WrappedLink, (0, _extends2["default"])({
    id: "featured-sp-card-sp-link-double-".concat(serviceProviderId),
    href: profileUrl,
    className: "featured-sp-title-link"
  }, dataTrackingPropsForProfileViews), truncatedSpName(2)) : truncatedSpName(2)), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 6,
    style: {
      maxHeight: '60px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/_react["default"].createElement(_certifiedPopOver["default"], null)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      "float": 'right',
      marginRight: '-36px'
    },
    role: "presentation",
    src: certifiedIcon,
    alt: "Certified"
  })))), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-ratings-row",
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.RatingDisplay, {
    rating: starRating,
    ratingFontSize: "1.2em",
    reviewCount: reviewCount,
    reviewCountNumberOnly: true,
    reviewFontSize: "1.2em",
    starSize: "1.2em"
  })), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-description-raq-row",
    key: "2"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 6
  }, /*#__PURE__*/_react["default"].createElement(_reactTruncateMarkup["default"], {
    lines: 3
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-description"
  }, description))), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 6
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      "float": 'right'
    }
  }, /*#__PURE__*/_react["default"].createElement(_raqButton["default"], {
    serviceProviderId: serviceProviderId,
    requestAQuoteUrl: raqUrl,
    customClass: "featured-raq-button",
    LinkWrapperComponent: LinkWrapperComponent,
    dataTrackingPropsForRaqBtn: dataTrackingPropsForRaqBtn
  }))))] : /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 1,
    style: {
      alignSelf: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.RatingDisplay, {
    customClass: "featured-rating-display",
    rating: starRating,
    ratingFontSize: "1.5em",
    ratingLocation: "top",
    reviewCount: reviewCount,
    reviewCountNumberOnly: true,
    reviewCountLocation: "bottom",
    reviewFontSize: "1.2em",
    starSize: "0.75em"
  })), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 8,
    style: {
      alignSelf: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "About this pro"), /*#__PURE__*/_react["default"].createElement(_reactTruncateMarkup["default"], {
    lines: 3
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-description"
  }, description)), !!profileUrl ? /*#__PURE__*/_react["default"].createElement(WrappedLink, (0, _extends2["default"])({
    id: "featured-sp-card-read-more-link-".concat(serviceProviderId),
    href: profileUrl,
    style: {
      color: _stylesColors["default"].teal
    }
  }, dataTrackingPropsForProfileViews), "Read more") : null, reviewCount > 0 || !!profileUrl ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '10px'
    }
  }, reviewCount > 0 && showReviewsLink ? /*#__PURE__*/_react["default"].createElement(WrappedLink, (0, _extends2["default"])({
    id: "featured-sp-card-view-consumer-reviews-link-".concat(serviceProviderId),
    className: "text-info featured-view-more",
    href: reviewsUrl
  }, dataTrackingPropsForProfileViews), 'View Consumer Reviews ', /*#__PURE__*/_react["default"].createElement("i", {
    style: {
      fontWeight: 'bold'
    },
    className: "icon icon-right-open-big"
  })) : !!profileUrl ? /*#__PURE__*/_react["default"].createElement(WrappedLink, (0, _extends2["default"])({
    id: "featured-sp-card-view-business-profile-link-".concat(serviceProviderId),
    className: "text-info featured-view-more",
    href: profileUrl
  }, dataTrackingPropsForProfileViews), 'View Business Profile ', /*#__PURE__*/_react["default"].createElement("i", {
    style: {
      fontWeight: 'bold'
    },
    className: "icon icon-right-open-big"
  })) : null) : null), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 3,
    style: {
      alignSelf: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_raqButton["default"], {
    serviceProviderId: serviceProviderId,
    requestAQuoteUrl: raqUrl,
    LinkWrapperComponent: LinkWrapperComponent,
    dataTrackingPropsForRaqBtn: dataTrackingPropsForRaqBtn,
    customClass: "featured-raq-button"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden-lg hidden-md"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-title-row"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 6
  }, !!profileUrl ? /*#__PURE__*/_react["default"].createElement(WrappedLink, (0, _extends2["default"])({
    id: (0, _concat["default"])(_context = "featured-sp-card-sp-link-".concat(singleFeaturedPro ? 'single' : 'double', "-")).call(_context, serviceProviderId),
    href: profileUrl,
    className: "featured-sp-title-link"
  }, dataTrackingPropsForProfileViews), truncatedSpName(1)) : truncatedSpName(1)), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 6,
    className: "featured-sp-info-hover"
  }, /*#__PURE__*/_react["default"].createElement(_featuredSPInfoHover["default"], {
    singleFeaturedPro: false
  }))), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-ratings-row"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.RatingDisplay, {
    rating: starRating,
    ratingFontSize: "1.2em",
    reviewCount: reviewCount,
    reviewCountNumberOnly: true,
    reviewFontSize: "1.2em",
    starSize: "1.2em"
  })), /*#__PURE__*/_react["default"].createElement(_featuredIcons["default"], {
    postalCode: postalCode,
    starRating: starRating,
    awards: awards,
    ratings: ratings,
    listedSinceYear: listedSinceYear,
    customClass: "featured-icons"
  }), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-description-row"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_reactTruncateMarkup["default"], {
    lines: 3
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-description"
  }, description))))));
};
FeaturedCardBody.propTypes = {
  singleFeaturedPro: _propTypes["default"].bool.isRequired,
  serviceProviderId: _propTypes["default"].number.isRequired,
  raqUrl: _propTypes["default"].string.isRequired,
  profileUrl: _propTypes["default"].string,
  reviewsUrl: _propTypes["default"].string.isRequired,
  serviceProviderName: _propTypes["default"].string,
  description: _propTypes["default"].string,
  reviewCount: _propTypes["default"].number,
  postalCode: _propTypes["default"].string.isRequired,
  starRating: _propTypes["default"].number,
  awards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string,
    images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      size: _propTypes["default"].string,
      url: _propTypes["default"].string
    }))
  })),
  ratings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    starRating: _propTypes["default"].number
  })),
  listedSinceYear: _propTypes["default"].string.isRequired,
  showReviewsLink: _propTypes["default"].bool.isRequired,
  LinkWrapperComponent: _propTypes["default"].element,
  // eslint-disable-next-line react/forbid-prop-types
  dataTrackingPropsForRaqBtn: _propTypes["default"].object,
  // eslint-disable-next-line react/forbid-prop-types
  dataTrackingPropsForProfileViews: _propTypes["default"].object
};
FeaturedCardBody.defaultProps = {
  profileUrl: '',
  serviceProviderName: '',
  description: '',
  awards: [],
  ratings: [],
  starRating: undefined,
  reviewCount: 0,
  LinkWrapperComponent: null,
  dataTrackingPropsForRaqBtn: {},
  dataTrackingPropsForProfileViews: {}
};
var _default = exports["default"] = FeaturedCardBody;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/featuredCardBody.js
// module id = 6484
// module chunks = 25